import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDeskOffice: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="desk-office"><path d="M2.75 18.25V5.75H21.25V18.25H11.25V5.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 9.75V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDeskOffice;
